import React from 'react';
import { SvgIcon } from '@mui/material';

const AiIcon = props => {
  return (
    <SvgIcon {...props}>
      <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 3.333A2.667 2.667 0 003.333 6v4.667h5.333V6A2.667 2.667 0 006 3.333zM11.333 6A5.333 5.333 0 10.667 6v12a1.333 1.333 0 002.666 0v-4.667h5.333V18a1.333 1.333 0 002.667 0V6zM18 .667c.736 0 1.333.597 1.333 1.333v16a1.333 1.333 0 01-2.666 0V2c0-.736.596-1.333 1.333-1.333z"
          fill="#fff"
        />
      </svg>
    </SvgIcon>
  );
};

export default AiIcon;
